import { bootstrapApplication } from '@angular/platform-browser';
import { ShopperAppComponent } from './shopper-app.component';
import { shopperAppConfig } from './shopper-app.config';

bootstrapApplication(ShopperAppComponent, shopperAppConfig)
  .catch((err) => console.error(err)); 